
import React, { useState } from 'react';
import { Input, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import './SubmitTicket.css';

const { TextArea } = Input;

const SubmitTicket = () => {
  const [issue, setIssue] = useState('');
  const [request, setRequest] = useState('');
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleUploadChange = ({ fileList }) => {
    const maxFileSize = 5 * 1024 * 1024; // 5MB
    const newFileList = fileList.slice(-1); // Garder seulement le dernier fichier
    if (newFileList.length > 0 && newFileList[0].size > maxFileSize) {
      message.error('Le fichier est trop volumineux (maximum 5MB).', 5);
      return;
    }
    setFileList(newFileList);
  };

  const handleSubmit = async () => {
    if (!issue || !request) {
      message.error('Veuillez remplir les champs Issue et Request.', 5);
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('issue', issue);
      formData.append('request', request);
      if (fileList.length > 0) {
        formData.append('file', fileList[0].originFileObj);
      }

      console.log('Envoi des données vers /Backend/admin_submit_ticket.php');
      const response = await fetch('/Backend/admin_submit_ticket.php', {
        method: 'POST',
        credentials: 'include',
        body: formData,
      });
      console.log('Statut HTTP:', response.status);
      const text = await response.text();
      console.log('Réponse brute:', text);
      let data;
      try {
        data = JSON.parse(text);
        console.log('Réponse:', data);
      } catch (e) {
        console.error('Erreur de parsing JSON:', e, 'Texte reçu:', text);
        throw new Error('Réponse non-JSON reçue du serveur.');
      }

      if (response.ok && data.message === 'Ticket soumis avec succès') {
        message.success('Votre ticket a été enregistré avec succès dans la base de données !', 5);
        setIssue('');
        setRequest('');
        setFileList([]);
      } else {
        if (response.status === 403) {
          message.error('Session expirée. Veuillez vous reconnecter.', 5);
          navigate('/adminlogin');
        } else {
          message.error(data.error || 'Une erreur est survenue lors de la soumission du ticket.', 5);
        }
      }
    } catch (error) {
      console.error('Erreur réseau:', error.message);
      message.error(`Erreur réseau: ${error.message}`, 5);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="submit-ticket-container">
      <h2 className="section-title">Submit A Ticket</h2>
      <div className="ticket-form">
        <div className="form-group">
          <label>Issue</label>
          <Input
            placeholder="Enter issue"
            value={issue}
            onChange={(e) => setIssue(e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label>Your request *</label>
          <TextArea
            placeholder="Write your message"
            value={request}
            onChange={(e) => setRequest(e.target.value)}
            autoSize={{ minRows: 4, maxRows: 6 }}
            disabled={loading}
          />
        </div>
        <div className="form-group">
          <label>Upload a file</label>
          <Upload
            beforeUpload={() => false} // Prevent automatic upload
            onChange={handleUploadChange}
            fileList={fileList}
            accept=".doc,.docx,.xls,.xlsx,.pdf,.jpg,.png,.gif"
            maxCount={1}
            disabled={loading}
          >
            <Button icon={<UploadOutlined />}>Choose File</Button>
          </Upload>
          {fileList.length === 0 ? (
            <p>No file chosen</p>
          ) : (
            <p>File chosen: {fileList[0].name} (Max size 5MB, allowed extensions: .doc, .docx, .xls, .xlsx, .pdf, .jpg, .png, .gif)</p>
          )}
        </div>
        <Button type="primary" onClick={handleSubmit} loading={loading}>
          Submit
        </Button>
      </div>
    </div>
  );
};

export default SubmitTicket;
